import * as React from "react";
const SvgHigh = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6.5 15L12.5 9L18.5 15", stroke: "#EC5A53", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgHigh;
